import { FC } from 'react'
import styles from './footer.module.scss'

export const Footer: FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <p className={styles.copyright}>
          © {new Date().getFullYear()} Hapttic. All rights reserved.
        </p>
        <div className={styles.footerLinks}>
          <a
            className={styles.link}
            href="https://hapttic.com/terms"
            rel="noopener noreferrer"
            target="_blank"
          >
            Terms and Conditions
          </a>
          <a
            className={styles.link}
            href="https://hapttic.com/privacy-policy"
            rel="noopener noreferrer"
            target="_blank"
          >
            Privacy Policy
          </a>
          <a
            className={styles.link}
            href="https://hapttic.com/help-center"
            rel="noopener noreferrer"
            target="_blank"
          >
            Help Center
          </a>
        </div>
      </div>
    </footer>
  )
}
